export default __webpack_public_path__ + "static/media/construction.d59f1e87.jpg";